export class AccountNotFoundError extends Error {}
